export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

// The ONE USD<->INR rate for the admin bundle.
//
// This MIRRORS the server's single source (luxury-life-server helpers/currency.js,
// env var `USD_INR_RATE`). It has to be a mirror rather than a read: the admin is a
// CRA bundle, so it cannot see the server's environment — only vars inlined at build
// time. Keep the two defaults identical; if the business rate moves, it moves in
// helpers/currency.js and here, and the admin must be rebuilt for it to take effect.
//
// Almost nothing should need this. Every money figure the API returns is ALREADY
// normalised server-side; the one consumer (member-engagement `toINR`) is a legacy
// fallback for payloads that predate that. Do not add new client-side conversion —
// convert on the server, where the rate actually lives.
export const USD_INR_RATE =
  Number(process.env.REACT_APP_USD_INR_RATE) > 0
    ? Number(process.env.REACT_APP_USD_INR_RATE)
    : 95;
